<template>
  <div class="userprojectindex">
    <el-row :gutter="15" style="display: flex; justify-content: space-between; height: 100%">
      <el-col :span="16">
        <el-card class="box-card" shadow="always" style="margin: 0 0 15px; height: 49%">
          <div style="line-height: 40px">
            <span style="font-size: 18px; border-bottom: 3px solid #558bf9">{{ $t('xmzy.ProjectDetails') }}</span>
          </div>
          <div style="height: 86%">
            <el-row style="height: 100%" :gutter="20">
              <el-col :span="8" class="textP">
                <img :src="this.$store.state.baseUrl + projectInfos.proj24" />
              </el-col>
              <el-col :span="16" class="textP">
                <el-row style="height: 100%">
                  <el-col :span="24" class="MarginB20">
                    <el-row :gutter="10">
                      <el-col :span="6">
                        <div class="MarginB20">
                          <p class="p1" :title="$t('xmzy.ProjectName')">{{ $t('xmzy.ProjectName') }}</p>
                          <p>{{ projectInfos.proj03 }}</p>
                        </div>
                        <div>
                          <p class="p4" :title="$t('xmzy.ProjectManager')">{{ $t('xmzy.ProjectManager') }}</p>
                          <p :title="projectInfos.admin">
                            {{ projectInfos.admin }}
                          </p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="MarginB20">
                          <p class="p3" :title="$t('xmzy.ProjectNumber')">{{ $t('xmzy.ProjectNumber') }}</p>
                          <p>{{ projectInfos.proj02 }}</p>
                        </div>
                        <div>
                          <p class="p8" :title="$t('xmzy.Overallconstructionperiod')">{{
                            $t('xmzy.Overallconstructionperiod') }}</p>
                          <p>{{ projectInfos.proj14 }}</p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="MarginB20">
                          <p class="p2" :title="$t('xmzy.StartDate')">{{ $t('xmzy.StartDate') }}</p>
                          <p>{{ projectInfos.proj20 }}</p>
                        </div>
                        <div>
                          <p class="p6" :title="$t('xmzy.ConsultingContracts')">{{ $t('xmzy.ConsultingContracts') }}</p>
                          <p>{{ projectInfos.proj08 }}</p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="MarginB20">
                          <p class="p2" :title="$t('xmzy.ScheduledToBeCompleted')">{{ $t('xmzy.ScheduledToBeCompleted')
                          }}</p>
                          <p>{{ projectInfos.proj21 }}</p>
                        </div>
                        <div>
                          <p class="p5" :title="$t('xmzy.OverallInvestment')">{{ $t('xmzy.OverallInvestment') }}</p>
                          <p>{{ projectInfos.proj19 }}</p>
                        </div>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="24" class="MarginB20">
                    <p class="p7" :title="$t('xmzy.Projectaddress')">{{ $t('xmzy.Projectaddress') }}</p>
                    <p :title="projectInfos.proj13">
                      {{ projectInfos.proj13 }}
                    </p>
                  </el-col>
                  <el-col :span="24">
                    <el-input :autosize="{ minRows: 7, maxRows: 7 }" v-if="projectInfos.proj23" readonly type="textarea"
                      v-model="projectInfos.proj23"></el-input>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-card>
        <el-card class="box-card" shadow="always" style="width: 50%; float: left; height: 49%">
          <div style="height: 40px">
            <span style="font-size: 18px; border-bottom: 3px solid #558bf9">{{ $t('xmzy.ProjectNotice') }}</span>
          </div>
          <div v-if="GetNotices.length">
            <el-row v-for="item in GetNotices" :key="item.noti01"
              :style="'line-height:27px;color:' + item.pmsg04 + ';'">
              <el-col :span="2">
                <img style="width: 16px; height: 16px" src="@/assets/img/TongZ.png" alt />
              </el-col>
              <el-col :span="14">
                <span style="
                    cursor: pointer;
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  " @click="showNotices(item)">{{ item.pmsg02 }}</span>
              </el-col>
              <el-col :span="8">
                <span style="
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  ">{{ item.pmsg07N }}</span>
              </el-col>
            </el-row>
          </div>
          <img v-else style="width: 40%; margin-left: 30%; margin-top: 10%" src="@/assets/img/empty.png" alt />
        </el-card>
        <el-card class="box-card" shadow="always" style="width: 48%; float: right; height: 49%">
          <div style="height: 40px">
            <span style="font-size: 18px; border-bottom: 3px solid #558bf9">{{ $t("xmzy.Todotasks") }}</span>
          </div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <!-- <el-tab-pane :label="$t('xmzy.Formtodo')" name="first"></el-tab-pane> -->
            <el-tab-pane :label="$t('xmzy.Workorderpending')" name="second"></el-tab-pane>
            <!-- <el-tab-pane :label="$t('xmzy.Workorderpending')" name="third"></el-tab-pane> -->
          </el-tabs>
          <div v-if="activeName == 'first'" class="hiddenScroll" style="overflow: visible; height: 265px">
            <div v-if="formapplyList.length">
              <el-row @click.native="go(item)" class="DB" v-for="(item, index) in formapplyList" :key="index">
                <i v-if="item.famp13 == 1" title="催办" class="onei el-icon-message-solid"></i>
                <el-col :span="2">
                  <userImage :username="item.user04" :imgUrl="$store.state.baseUrl + item.user13" bgcolor="#fff"
                    ftColor="#000" width="30px" height="30px" MarginTop="15px"></userImage>
                </el-col>
                <el-col :span="4">
                  <span style="font-size: 13px; font-weight: bold">{{
                    item.user04
                  }}</span>
                </el-col>
                <el-col class="textEllipsis" :span="8">
                  <span :title="item.fmap03" style="font-size: 15px; font-weight: bold">{{ item.fmap03 }}</span>
                </el-col>
                <el-col :span="10" style="line-height: 30px; text-align: right">
                  <el-row>
                    <el-col :span="24">审核：{{ item.auditUsers }}</el-col>
                    <el-col :span="24">{{ item.famp10 }}</el-col>
                  </el-row>
                </el-col>
                <div class="twoi">
                  {{
                    item.famp11 == 1
                      ? "进行中"
                      : scope.row.famp11 == 2
                        ? "已通过"
                        : scope.row.famp11 == 3
                          ? "未通过"
                          : "已撤回"
                  }}
                </div>
                <div class="twoi2">
                  {{ item.parent.parentName }}
                </div>
              </el-row>
            </div>
            <img v-else style="width: 40%; margin-left: 30%; margin-top: 10%" src="@/assets/img/empty.png" alt />
          </div>

          <div v-if="activeName == 'second'" class="hiddenScroll" style="overflow: auto; height: 265px">
            <div v-if="plandetailList.length">
              <el-row @click.native="go(item)" v-for="(item, index) in plandetailList" :key="index" class="DB">
                <i v-if="item.warn" title="预警" class="onei el-icon-message-solid"></i>
                <el-col :span="8">
                  <userImage :title="item.user04" v-for="(item, index) in item.pldt12List" :key="index"
                    :username="item.user04" :imgUrl="$store.state.baseUrl + item.user13" bgcolor="#fff" ftColor="#000"
                    width="30px" height="30px" MarginTop="15px" style="display: inline-block"></userImage>
                </el-col>
                <el-col :span="6">
                  <span style="font-size: 24px; font-weight: bold">{{
                    item.pldt04
                  }}</span>
                </el-col>
                <el-col :span="10" style="line-height: 30px; text-align: left">
                  <el-row>
                    <el-col :span="24">{{ item.pldt20 }}</el-col>
                    <el-col :span="24">计划结束时间：{{ item.pldt07N }}</el-col>
                  </el-row>
                </el-col>
                <div class="twoi" :title="item.State">
                  {{
                    item.State.length > 3
                      ? item.State.substr(0, 3) + "..."
                      : item.State
                  }}
                </div>
              </el-row>
            </div>

            <img v-else style="width: 40%; margin-left: 30%; margin-top: 10%" src="@/assets/img/empty.png" alt />
          </div>

          <div v-if="activeName == 'third'" class="hiddenScroll" style="overflow: auto; height: 265px">
            <div v-if="wordkorderList.length">
              <el-row @click.native="go(item)" v-for="(item, index) in wordkorderList" :key="index" class="DB">
                <i v-if="item.Fuck" title="催办" class="onei el-icon-message-solid"></i>
                <el-col :span="2">
                  <userImage :username="item.wkod11Name" :imgUrl="$store.state.baseUrl + item.user13" bgcolor="#fff"
                    ftColor="#000" width="30px" height="30px" MarginTop="15px"></userImage>
                </el-col>
                <el-col :span="5">
                  <span style="font-size: 16px; font-weight: bold">{{
                    item.wkod11Name
                  }}</span>
                </el-col>
                <el-col :span="7">
                  <span style="font-size: 24px; font-weight: bold">{{
                    item.wkod02
                  }}</span>
                </el-col>
                <el-col :span="9" :offset="1" style="line-height: 30px; text-align: left">
                  <el-row>
                    <el-col :span="24">执行人：{{ item.wkod11Name }}</el-col>
                    <el-col :span="24">审批人：{{ item.wkod19Name }}</el-col>
                  </el-row>
                </el-col>
                <div class="twoi" :title="item.state">
                  {{
                    item.state.length > 3
                      ? item.state.substr(0, 3) + "..."
                      : item.state
                  }}
                </div>
              </el-row>
            </div>

            <img v-else style="width: 40%; margin-left: 30%; margin-top: 10%" src="@/assets/img/empty.png" alt />
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <div style="margin-bottom: 20px; height: 49%">
          <el-card class="box-card" shadow="always" style="height: 100%; overflow: hidden">
            <div style="height: 40px">
              <span style="font-size: 18px; border-bottom: 3px solid #558bf9">{{ $t('xmzy.Workdynamics') }}</span>
            </div>
            <div style="width: 100%; height: 89%">
              <el-tabs v-model="activeTypeName">
                <el-tab-pane v-for="(item, index) in weiboList" :label="item.type" :name="item.id" :key="index">
                  <div v-if="item.List.length" style="overflow: auto; height: 280px">
                    <el-row v-for="(item2, index2) in item.List" :key="index2"
                      style="line-height: 27px; margin-bottom: 5px">
                      <el-col :span="1">
                        <p style="
                            width: 10px;
                            height: 10px;
                            line-height: 27px;
                            border-radius: 50%;
                            background: rgb(59, 94, 215);
                            margin-top: 8px;
                          "></p>
                      </el-col>
                      <el-col @click.native="showWeiBo(item2.content)" :span="16">
                        <p v-if="item2.title" v-html="item2.title" style="
                            cursor: pointer;
                            font-weight: 700;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          "></p>
                        <p v-else style="cursor: pointer; font-weight: 700">
                          {{ this.$t('xmzy.无标题') }}
                        </p>
                      </el-col>
                      <el-col :span="6" :offset="1">
                        <el-button size="mini" type="primary" style="cursor: auto">{{ item2.name }}</el-button>
                      </el-col>
                      <el-col :span="24">
                        <span style="font-size: 12px; color: #555">
                          {{ item2.time }}
                        </span>
                      </el-col>
                    </el-row>
                  </div>
                  <img v-else style="width: 40%; margin-left: 30%; margin-top: 10%" src="@/assets/img/empty.png" alt />
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
        <div style="height: 49%">
          <el-card class="box-card" shadow="always" style="height: 100%">
            <div style="height: 40px">
              <span style="font-size: 18px; border-bottom: 3px solid #558bf9">{{ $t('xmzy.DataDynamics') }}</span>
            </div>
            <div id="cy" style="width: 100%; height: 80%"></div>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <!-- 这里是添加事件 -->
    <el-drawer :title="this.$t('xmzy.项目通知')" style="font-weight: 700; font-size: 14px" :visible.sync="showNotices2"
      size="50%">
      <!-- <ckediter4 ref="ck" :func="setCk" v-model="NoticesInfo"></ckediter4> -->
      <div style="padding: 0 20px; overflow: auto" v-html="NoticesInfo">
        {{ NoticesInfo }}
      </div>
    </el-drawer>

    <el-drawer :title="this.$t('xmzy.内容')" style="font-weight: 700; font-size: 14px" size="50%"
      :visible.sync="weiboShow">
      <ckediter4 ref="ck" :func="setCk" v-model="weiboContent"></ckediter4>
    </el-drawer>
  </div>
</template>

<script>
import {
  GetProjectInfo,
  GetProjectNotice,
  GetCiY,
  GetFormTask,
  GetPlanTask,
  GetWorkOrderTask,
  GetWeiBoList,
} from "@/setAxios.js";
import { v4 as uuidv4 } from "uuid";
import userImage from "@/components/userImage";

import ckediter4 from "@/components/ck.vue";
export default {
  data() {
    return {
      showNotices2: false,
      NoticesInfo: "",
      projectInfos: {},
      GetNotices: [],
      cyData: [],
      formapplyList: [],
      plandetailList: [],
      wordkorderList: [],
      activeName: "second",
      weiboList: [],
      activeTypeName: "",
      weiboShow: false,
      weiboContent: "",
    };
  },
  components: { userImage, ckediter4 },
  // 利用计算属性
  computed: {
    xidUpdata() {
      return this.$store.state.xid;
    },
  },
  //监听执行
  watch: {
    xidUpdata(newVal) {
      this.GetProjectInfo();
      this.GetNotice();
      this.getData();
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetCiY(params).then((res) => {
        this.cyData = res.Data;
        this.initCY();
      });
    },
  },
  created() {
    this.$store.state.btnStyle = ["btns", "btnss", "btns", "btns"];
    if (localStorage.xid) {
      this.GetProjectInfo();
      this.GetNotice();
      this.getData();
      this.GetWeiBoList();
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetCiY(params).then((res) => {
        this.cyData = res.Data;
        this.initCY();
      });
    }
  },
  methods: {
    showWeiBo(data) {
      this.weiboShow = true;
      this.weiboContent = null;
      this.weiboContent = data;
    },
    async GetWeiBoList() {
      let res = await GetWeiBoList({ params: { xid: localStorage.xid } });
      if (res.Data.length) {
        this.weiboList = res.Data;
        this.weiboList.forEach((ele) => {
          ele.id = uuidv4();
        });
        this.activeTypeName = res.Data[0].id;
      }
    },
    go(item) {
      if (this.activeName == "first") {
        this.$router.push({
          path: "/" + item.parent.path,
          query: item.parent.fctm01
            ? {
              key: this.$UrlEncode.encode(
                JSON.stringify({
                  type: item.parent.fctm01,
                  name: item.parent.fctm02,
                  isTask: true,
                })
              ),
            }
            : {},
        });
      } else if (this.activeName == "second") {
        this.$router.push({ name: "progressPlan", params: item });
      } else if (this.activeName == "third") {
        this.$router.push({ name: "workOrder", params: item });
      }
    },
    handleClick(tab, event) {
      let params = {
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
      };
      if (tab.label == "表单待办") {
        this.GetFormTask(params);
      } else if (tab.label == "进度待办") {
        this.GetPlanTask(params);
      } else {
        this.GetWorkOrderTask(params);
      }
    },
    async GetFormTask(params) {
      let _this = this;
      let res = await GetFormTask({ params });
      this.formapplyList = res.Data.filter((el) => {
        let item = _this.find(_this.$store.state.MenuTemplateList, el.famp14);
        if (item) {
          el.parent = item;
          return true;
        } else {
          return false;
        }
      });
    },
    find(list, id) {
      let _this = this;
      let result;
      for (let index = 0; index < list.length; index++) {
        const el = list[index];
        if (el.fctm01 == id) {
          result = el;
          return result;
        } else if (el.children && el.children.length) {
          result = _this.find(el.children, id);
          if (result) {
            return result;
          }
        }
      }
      return result;
    },
    async GetPlanTask(params) {
      let res = await GetPlanTask({ params });
      this.plandetailList = res.Data;
    },
    async GetWorkOrderTask(params) {
      let res = await GetWorkOrderTask({ params });
      this.wordkorderList = res.Data;
    },
    initCY() {
      var _this = this;
      if (this.cyData != null) {
        var words = [];

        this.cyData.forEach((v, index) => {
          words.push([v.name, this.cyData.length - index]);
        });

        var option = {
          tooltip: {
            show: true,

            formatter: function (item) {
              return item[0];
            },
          },
          list: words,
          maxFontSize: 25,
          fontSizeFactor: 0.1,
          minFontSize: 8,
          imageShape: "",
          ellipticity: 1,
          rotateRatio: 0, // 字体倾斜(旋转)概率，1代表总是倾斜(旋转)
          // 点击事件
          click(a, b, c) {
            let name = a[0];
            switch (name) {
              case "工单任务":
                _this.$router.push("workOrder");
                break;
              case "工程动态":
                _this.$router.push("weibo");
                break;
              case "进度计划":
                _this.$router.push("progressPlan");
                break;
              case "条码点位":
                _this.$router.push("location");
                break;
              case "话题讨论":
                _this.$router.push("discussTheTopic");
                break;
              case "资料列表":
                _this.$router.push("dataList");
                break;
              case "流程表单":
                // _this.$router.push("userFlowChart");
                break;
              default:
                break;
            }
          },
        };
        var wc = new Js2WordCloud(document.getElementById("cy"));
        wc.showLoading({
          backgroundColor: "#fff",
          text: "加载中...",
          effect: "spin",
        });
        setTimeout(function () {
          wc.hideLoading();
          wc.setOption(option);
        }, 1000);
      }
    },

    setCk() {
      try {
        document.getElementsByClassName("cke_top")[0].remove();
        document.getElementsByClassName("cke_bottom")[0].remove();
        document
          .getElementsByClassName("cke_contents")[0]
          .style.setProperty("height", "850px", "important");
      } catch { }
    },

    showNotices(data) {
      this.showNotices2 = true;
      this.NoticesInfo = null;
      this.NoticesInfo = data.pmsg05;
    },
    // 获取待办任务
    getData() {
      let params = {
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
      };
      this.GetFormTask(params);
    },
    GetProjectInfo() {
      let params = {
        id: localStorage.getItem("xid"),
      };
      GetProjectInfo({ params }).then((res) => {
        this.projectInfos = res.Data;
        this.projectInfos.proj21 = this.projectInfos.proj21
          ? this.projectInfos.proj21.substr(
            0,
            this.projectInfos.proj21.lastIndexOf(" ")
          )
          : "";
        this.projectInfos.proj20 = this.projectInfos.proj20
          ? this.projectInfos.proj20.substr(
            0,
            this.projectInfos.proj20.lastIndexOf(" ")
          )
          : "";
      });
    },
    GetNotice() {
      let params = {
        id: localStorage.xid,
        pageIndex: 1,
        pageSize: 1000,
      };
      GetProjectNotice({ params }).then((res) => {
        this.GetNotices = res.Data.list;
        //(res, "通知公告dsadsadsadsa");
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../../../public/blottercss.css");

/deep/ .el-card__body {
  // height: 470px;
  height: 90%;
  overflow: auto;
}

/deep/ .el-drawer__body {
  overflow: auto;
}

.views img {
  width: 34px;
  height: 34px;
  position: absolute;
  left: 10px;
  top: 50%;
  margin-top: -17px;
}

.icon {
  // width: 1em;
  // height: 1em;
  // vertical-align: -0.15em;
  width: 22px;
  height: 22px;
  fill: currentColor;
  overflow: hidden;
}

.userprojectindex {
  height: 100%;

  .textP {
    height: 100%;

    p:nth-child(1) {
      margin: 5px 0;
      //letter-spacing: 2px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 20px;
    }

    .p1 {
      background: url("../../assets/img/Vector1.png") no-repeat left center;
      color: #527efa;
    }

    .p2 {
      background: url("../../assets/img/Vector2.png") no-repeat left center;
      color: #527efa;
    }

    .p3 {
      background: url("../../assets/img/Vector3.png") no-repeat left center;
      color: #527efa;
    }

    .p3 {
      background: url("../../assets/img/Vector3.png") no-repeat left center;
      color: #527efa;
    }

    .p4 {
      background: url("../../assets/img/Vector4.png") no-repeat left center;
      color: #527efa;
    }

    .p5 {
      background: url("../../assets/img/Vector5.png") no-repeat left center;
      color: #527efa;
    }

    .p6 {
      background: url("../../assets/img/Vector6.png") no-repeat left center;
      color: #527efa;
    }

    .p7 {
      background: url("../../assets/img/Vector7.png") no-repeat left center;
      color: #527efa;
    }

    .p8 {
      background: url("../../assets/img/Vector8.png") no-repeat left center;
      color: #527efa;
    }

    .p0 {
      background: url("../../assets/img/Vector.png") no-repeat left center;
      color: #527efa;
    }

    img {
      width: 100%;
      height: 100%;
      margin-bottom: 10px;
    }
  }
}

.el-drawer__header {
  font-size: 24px !important;
}

/deep/ .el-drawer {
  img {
    width: 100%;
    height: 100%;
  }
}

.MarginB20 {
  margin-bottom: 20px;
  font-size: 12px;
}

.DB {
  background: #f3f3f3;
  // background-image: linear-gradient(-90deg, #29bdd9 0%, #276ace 100%);
  line-height: 60px;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 15px;
  cursor: pointer;
  padding-top: 25px;
  padding-bottom: 25px;

  .onei {
    position: absolute;
    top: 5px;
    left: 2px;
    font-size: 16px;
    color: red;
  }

  .twoi {
    display: block;
    position: absolute;
    top: 1px;
    right: 1px;
    font-size: 12px;
    line-height: 20px;
    width: 55px;
    height: 25px;
    background-color: #16b6f5;
    text-align: right;
    padding-right: 5px;
    border-radius: 0 15px 0 30px;
    color: #ffffff;
  }


  .twoi2 {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 12px;
    line-height: 20px;
    width: auto;
    padding: 1px 10px;
    height: auto;
    background-color: #16b6f5;
    text-align: right;
    // padding-right: 5px;
    border-radius: 0 30px 0 0;
    color: #ffffff;
  }
}
</style>
